import { render, staticRenderFns } from "./DuplicateProjectModal.vue?vue&type=template&id=9c1a37a6&scoped=true"
import script from "./DuplicateProjectModal.vue?vue&type=script&lang=js"
export * from "./DuplicateProjectModal.vue?vue&type=script&lang=js"
import style0 from "./DuplicateProjectModal.vue?vue&type=style&index=0&id=9c1a37a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_babel-core@7.0.0-bridge.0_@babel+core@7.25.8__cac_7uvw3tio4x4egbur7wz2ifovwa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1a37a6",
  null
  
)

export default component.exports